<template>
  <div @click.self="closeModal" class="modalContainer" role="dialog" aria-modal="true" aria-labelledby="modal-title" :aria-describedby="modalDescription">
    <div class="modalWrapper" ref="modalWrapper" tabindex="-1">
      <button @click="closeModal" class="close" type="button" :aria-label="t('common.closeModal')">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M8.1161 6.6228L7.75908 6.97635L8.11437 7.33163L13.4572 12.6745L12.6745 13.4572L11.8466 12.6294L11.8449 12.6277L7.37718 8.11608L7.02364 7.75906L6.66835 8.11435L1.32551 13.4572L0.542786 12.6745L5.88563 7.33163L6.24062 6.97664L5.8842 6.62309L0.543158 1.32514L1.32551 0.542787L6.66835 5.88563L7.02334 6.24061L7.37689 5.88419L12.6748 0.543155L13.4572 1.32551L12.6294 2.15333L12.6277 2.15504L8.1161 6.6228ZM12.7648 13.5475C12.7649 13.5476 12.765 13.5478 12.7651 13.5479L12.7648 13.5475ZM0.452113 12.7651L0.452145 12.7651C0.452134 12.7651 0.452123 12.7651 0.452113 12.7651Z"
            fill="black"
            stroke="black"
          />
        </svg>
      </button>
      <div class="modalHeader" v-if="from == 'orderTimePassed'">
        <h2 id="modal-title">{{ t('storeModal.dateAndTime.orderTimePassed') }}</h2>
        <p id="modal-desc" role="alert">{{ t('storeModal.dateAndTime.selectAfterCurrent') }}</p>
      </div>
      <div class="modalHeader" v-if="from == 'needMoreTime'">
        <h2 id="modal-title">{{ t('storeModal.dateAndTime.needMoreTimeTitle') }}</h2>
        <p id="modal-desc" role="alert">{{ t('storeModal.dateAndTime.messageWithDate', { message: message }) }}</p>
      </div>
      <h2 v-if="from !== 'orderTimePassed' && from !== 'needMoreTime'" id="modal-title" class="sr-only">
        {{ t('storeModal.dateAndTime.selectOrderDetails') }}
      </h2>
      <div
        v-if="selectedServiceData && from !== 'needMoreTime' && from !== 'orderTimePassed' && !isReorder"
        class="serviceTypes"
      >
        <label class="serviceTypeLabel" id="service-type-label">{{ t('storeModal.dateAndTime.serviceTypeLabel') }}</label>
        <SegmentedControl
          v-if="visibleServices.length"
          :elements="visibleServices"
          :elementId="'service_type_id'"
          :selectedId="selectedServiceData.service_type_id"
          :elementName="visibleServices[0].display_name ? 'display_name' : 'name'"
          @change="changeService"
          :loading="buttonLoader"
          :ariaLabel="t('storeModal.dateAndTime.serviceTypeAriaLabel')"
        />
      </div>
      <div
        v-if="selectedServiceData && from !== 'needMoreTime' && from !== 'orderTimePassed' && !isReorder"
        class="line"
      ></div>
      <div v-if="selectedServiceData && from !== 'needMoreTime' && from !== 'orderTimePassed'" class="orderInfo">
        <div>
          <div
            v-if="this.selectedServiceData.requires_address && addressInputIsVisible"
            class="inputWrapper addressInput"
          >
            <div class="addressDetails">
              <div class="addressWrapper">
                <div v-if="selectedAddressLat && selectedAddressLat" class="remove">
                  <a @click="addressValue('')" href="#">
                    <img src="@/assets/icons/close.svg" :alt="t('common.closeIconAlt')" />
                  </a>
                </div>
                <RadarAutoComplete
                  :placeholder="t('storeModal.dateAndTime.enterAddressPlaceholder')"
                  :ariaLabel="t('storeModal.dateAndTime.searchDeliveryAddress')"
                  :reqiresAddress="true"
                  :from="'home'"
                  @addressSelected="getRadarAddressComponents"
                  ref="radarAutoComplete"
                  v-if="autoCompleteType == 'RADAR'"
                />
                <AutoComplete
                  @placeChanged="getLatAndLng"
                  :ariaLabel="t('storeModal.dateAndTime.searchDeliveryAddress')"
                  @input="addressValue"
                  :placeholder="t('storeModal.dateAndTime.enterAddressPlaceholder')"
                  :requiresAddress="true"
                  ref="autoComplete"
                  v-if="autoCompleteType == 'GOOGLE'"
                />
                <p v-if="v$.address.$error === true" class="validation">{{ t('storeModal.dateAndTime.enterAddressValidation') }}</p>
                <p v-if="!addressSelected" class="validation">{{ t('storeModal.dateAndTime.selectAddressFromList') }}</p>
                <p v-if="validAddressError" class="validation">
                  {{ validAddressError }}
                </p>
              </div>
              <input
                v-if="selectedServiceData.requires_address"
                type="text"
                :placeholder="t('storeModal.dateAndTime.aptSuitePlaceholder')"
                v-model="aptSuite"
              />
            </div>
          </div>
          <div
            v-if="
              selectedServiceData && selectedServiceData.requires_address && selectedAddress && !addressInputIsVisible
            "
          >
            <p class="name">
              {{ selectedAddress.address1 + ', ' + selectedAddress.state_code + ' ' + selectedAddress.postal_code }}
            </p>
            <p v-if="selectedAddress.address2">{{ t('storeModal.dateAndTime.aptSuiteLabel', { value: selectedAddress.address2 }) }}</p>
          </div>
          <p v-if="selectedStore && selectedServiceData && !selectedServiceData.requires_address" class="name">
            {{ selectedStore.name }}
          </p>
          <p
            v-if="
              selectedStore && !selectedServiceData.requires_address && !branding.display_options.hide_store_address
            "
          >
            {{ selectedStore.address1 }}, {{ selectedStore.city }}, {{ selectedStore.state }}
            {{ selectedStore.postal_code }}
          </p>
          <p v-if="selectedStore?.subtitle">{{ selectedStore.subtitle }}</p>
        </div>
        <button
          v-if="selectedServiceData && !selectedServiceData.requires_address && !isReorder"
          type="button"
          class="rightArrow"
          @click="changeLocation"
          :aria-label="t('storeModal.dateAndTime.changeLocationAria')"
        >
          <svg
            id="chevron.right"
            xmlns="http://www.w3.org/2000/svg"
            width="9.551"
            height="16.963"
            viewBox="0 0 9.551 16.963"
            aria-hidden="true"
            focusable="false"
          >
            <rect id="Rectangle_3463" data-name="Rectangle 3463" width="9.551" height="16.963" opacity="0" />
            <path
              id="Path_19795"
              data-name="Path 19795"
              d="M9.551,8.477a.874.874,0,0,0-.283-.645L1.533.254A.908.908,0,0,0,.889,0,.874.874,0,0,0,0,.889a.927.927,0,0,
                        0,.254.635L7.363,8.477.254,15.43A.909.909,0,0,0,0,16.065a.874.874,0,0,0,.889.889.877.877,0,0,0,.645-.264L9.268,9.121A.89.89,0,0,0,9.551,8.477Z"
            />
          </svg>
        </button>
        <a
          @click="changeAddressClicked"
          class="change"
          href="javascript:;"
          v-if="selectedServiceData && selectedServiceData.requires_address && !addressInputIsVisible && !isReorder"
        >
          <p>{{ t('storeModal.dateAndTime.change') }}</p>
        </a>
      </div>
      <div
        v-if="
          selectedServiceData?.requires_guest_count &&
          selectedServiceData &&
          (!from || isReorder) &&
          !isStoreTemporarilyClosed
        "
        class="inputWrapper"
        style="margin-top: 20px"
      >
        <label for="guestCount">{{ t('storeModal.dateAndTime.numberOfGuests') }}</label>
        <input v-model="guestCount" type="number" :placeholder="t('storeModal.dateAndTime.numberOfGuests')" id="guestCount" min="1" />
        <p v-if="v$.guestCount.$error === true" class="validation">
          <span v-if="v$.guestCount.requiredIf && v$.guestCount.requiredIf.$invalid">{{ t('storeModal.dateAndTime.enterGuestCount') }}</span>
          <span v-else-if="v$.guestCount.minValue && v$.guestCount.minValue.$invalid">{{ t('storeModal.dateAndTime.minGuestCount') }}</span>
        </p>
      </div>
      <div v-if="selectedStoreDays && day && hour">
        <div
          v-if="selectedStoreDays && day && hour && !from && !useASAPOrdersScheduler && !isReorder"
          class="line"
        ></div>
        <div
          v-if="selectedStoreDays && day && hour && !useASAPOrdersScheduler"
          class="daysAndHours"
          :class="{ reorderSpacing: isReorder }"
        >
          <div ref="dayDropdown" v-if="selectedStoreDays" class="inputWrapper">
            <label id="day-label">{{ t('storeModal.dateAndTime.selectDay') }}</label>
            <button
              type="button"
              @click="toggleDayDropdown"
              @keydown="handleDayKeydown"
              class="customSelect"
              :aria-expanded="dayDropdownIsOpen"
              aria-labelledby="day-label"
              aria-haspopup="listbox"
            >
              <svg
                class="arrow"
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                  fill="#171717"
                />
              </svg>
              <p>{{ day.formatted }}</p>
            </button>
            <div
              v-if="dayDropdownIsOpen"
              class="dropdown"
              :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
            >
              <div
                v-for="(day, index) in selectedStoreDays"
                :key="day.date"
                :data-day-index="index"
                @click="selectDay(index)"
                class="dropdownItem"
                :class="{ selected: index == selectedDayIndex }"
              >
                {{ day.formatted }}
              </div>
            </div>
          </div>
          <div ref="hourDropdown" v-if="selectedStoreDays" class="inputWrapper">
            <label id="time-label">{{ t('storeModal.dateAndTime.selectTime') }}</label>
            <button
              type="button"
              @click="toggleHourDropdown"
              @keydown="handleHourKeydown"
              class="customSelect"
              :aria-expanded="hourDropdownIsOpen"
              aria-labelledby="time-label"
              aria-haspopup="listbox"
            >
              <svg
                class="arrow"
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                  fill="#171717"
                />
              </svg>
              <p>{{ hour.formatted }}</p>
            </button>
            <div
              v-if="hourDropdownIsOpen"
              class="dropdown"
              :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
            >
              <div v-for="(hour, index) in selectedStoreDays[selectedDayIndex].hours" :key="hour.date">
                <template v-if="index === firstNextDayIndex">
                  <div class="nextDayLine"></div>
                  <div class="dateItem">{{ hour.nextDayDate }}</div>
                </template>
                <div
                  :data-hour-index="index"
                  @click="selectHour(index)"
                  class="dropdownItemTime"
                  :class="{ selected: index == selectedHourIndex }"
                >
                  {{ hour.formatted }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="useASAPOrdersScheduler" class="asapOrdersScheduler">
          <p v-if="closingSoonMessageShow" class="closingSoonMessage">
            {{ closingSoonMessage }}
          </p>
          <div class="radio-group">
            <div class="radio">
              <input
                :class="{ disabled: !isAsapAvailable }"
                name="orderType"
                value="ASAP"
                v-model="selectedOrderType"
                type="radio"
                id="asapOrder"
                :disabled="!isAsapAvailable"
              />
              <label class="radioLabel" :class="{ disabled: !isAsapAvailable }" for="asapOrder">{{ t('storeModal.dateAndTime.asapOrder') }}</label>
            </div>

            <div class="radio">
              <input
                :class="{ disabled: !isFutureAvailable }"
                :disabled="!isFutureAvailable"
                name="orderType"
                value="future"
                v-model="selectedOrderType"
                type="radio"
                id="futureOrder"
              />
              <label class="radioLabel" :class="{ disabled: !isFutureAvailable }" for="futureOrder">{{ t('storeModal.dateAndTime.futureOrder') }}</label>
            </div>
          </div>
        </div>
        <div class="futureOrders" v-if="selectedOrderType === 'future' && useASAPOrdersScheduler">
          <div class="daysAndHours startOrder">
            <div ref="dayDropdown" v-if="selectedStoreDays" class="inputWrapper">
              <label>{{ t('storeModal.dateAndTime.selectDay') }}</label>
              <div @click="toggleDayDropdown" class="customSelect">
                <svg
                  class="arrow"
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                    fill="#171717"
                  />
                </svg>
                <p>{{ day.formatted }}</p>
              </div>
              <div
                v-if="dayDropdownIsOpen"
                class="dropdown"
                :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
              >
                <div
                  v-for="(day, index) in selectedStoreDays"
                  :key="day.date"
                  v-show="hasSchedulableHours(day)"
                  :data-day-index="index"
                  @click="selectDay(index)"
                  class="dropdownItem"
                  :class="{ selected: index == selectedDayIndex }"
                >
                  {{ day.formatted }}
                </div>
              </div>
            </div>
            <div ref="hourDropdown" v-if="selectedStoreDays" class="inputWrapper">
              <label>{{ t('storeModal.dateAndTime.selectTime') }}</label>
              <div @click="toggleHourDropdown" class="customSelect">
                <svg
                  class="arrow"
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                    fill="#171717"
                  />
                </svg>
                <p>{{ hour.formatted }}</p>
              </div>
              <div
                v-if="hourDropdownIsOpen"
                class="dropdown"
                :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
              >
                <div v-for="(hour, index) in selectedStoreDays[selectedDayIndex].hours" :key="hour.date">
                  <template v-if="index === firstNextDayIndex">
                    <div class="nextDayLine"></div>
                    <div class="dateItem">{{ hour.nextDayDate }}</div>
                  </template>
                  <div
                    v-if="hour.formatted !== 'ASAP'"
                    :data-hour-index="index"
                    @click="selectHour(index)"
                    class="dropdownItemTime"
                    :class="{ selected: index == selectedHourIndex }"
                  >
                    {{ hour.formatted }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="isStoreTemporarilyClosed" class="storeClosedMessage">
        <p>
          {{ t('storeModal.dateAndTime.storeClosed') }}
        </p>
      </div>
      <div v-else class="loaderWrapper">
        <div class="loader"></div>
      </div>
      <p class="feedback error" v-if="error.status">
        {{ error.message }}
        <a @click="selectAnotherLocationClicked" class="selectLocation" href="javascript:;" v-if="error.link">
          <p>{{ t('storeModal.dateAndTime.selectAnotherLocation') }}</p>
        </a>
      </p>
      <button
        @click="buttonClicked"
        :disabled="
          buttonLoader ||
          (!selectedStoreDays && !isStoreTemporarilyClosed) ||
          (!day && !isStoreTemporarilyClosed) ||
          (!hour && !isStoreTemporarilyClosed)
        "
        class="startOrder"
      >
        <div v-if="buttonLoader" class="loader buttonLoader"></div>
        <template v-if="!buttonLoader">
          <template v-if="isStoreTemporarilyClosed">{{ t('storeModal.dateAndTime.selectAnotherStore') }}</template>
          <template v-else>{{ dayAndTimeSelected ? t('storeModal.dateAndTime.update') : t('storeModal.dateAndTime.startMyOrder') }}</template>
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { displayTime, displayShortDate } from '@/utils/dateFormat'

import useVuelidate from '@vuelidate/core'
import { requiredIf, minValue } from '@vuelidate/validators'

import { mapState, mapMutations } from 'vuex'
import { useI18n } from 'vue-i18n'

import customersApi from '@/api/customersApi'
import ordersApi from '@/api/ordersApi'
import { buildOrderPayload } from '@/utils/orderPayload'
import storesApi from '@/api/storesApi'

import AutoComplete from '@/components/GoogleMaps/AutoComplete.vue'
import RadarAutoComplete from '@/components/GoogleMaps/RadarAutoComplete.vue'
import SegmentedControl from '@/components/Elements/SegmentedControl.vue'

import addressMixins from '@/mixins/addressMixins'
import modalMixins from '@/mixins/modalMixins.js'

import { useFlag } from '@unleash/proxy-client-vue'

export default {
  setup() {
    const { t } = useI18n()
    const disableAsapOnHighLeadTime = useFlag('disable_asap_on_high_lead_time', { fallback: false })
    return {
      t,
      v$: useVuelidate(),
      disableAsapOnHighLeadTime,
    }
  },
  data() {
    return {
      day: null,
      hour: null,
      selectedDayIndex: 0,
      selectedHourIndex: 0,
      dayDropdownIsOpen: false,
      hourDropdownIsOpen: false,
      error: {
        status: false,
        message: '',
      },
      serviceTypeListIsVisible: false,
      storeServices: null,
      selectedServiceData: null,
      selectedAddressLat: null,
      selectedAddressLng: null,
      validAddressError: null,
      addressData: null,
      address: '',
      addressInputIsVisible: null,
      addressSelected: true,
      aptSuite: '',
      guestCount: '',
      useASAPOrdersScheduler: false,
      selectedOrderType: 'ASAP',
      isAsapAvailable: true,
      isFutureAvailable: true,
      closingSoonMessage: '',
      closingSoonMessageShow: false,
      timeZoneOffset: null,
      deliveryAddressBackup: null,
      deliveryAptSuiteBackup: '',
      isStoreTemporarilyClosed: false,
    }
  },
  props: ['from', 'message', 'storeId', 'isReorder'],
  components: {
    AutoComplete,
    RadarAutoComplete,
    SegmentedControl,
  },
  validations() {
    return {
      address: {
        requiredIf: requiredIf(() => this.selectedServiceData.requires_address && this.addressInputIsVisible),
      },
      guestCount: {
        requiredIf: requiredIf(() => this.selectedServiceData.requires_guest_count),
        minValue: minValue(1),
      },
    }
  },
  mixins: [addressMixins, modalMixins],
  watch: {
    selectedAddress() {
      if (this.selectedAddress) {
        this.addressInputIsVisible = false
      }
    },
    selectedOrderType(newOrderType) {
      // When order type changes to 'future', ensure ASAP is not selected. Today can hold
      // nothing but the ASAP pseudo-slot (store closing within the lead time), so the
      // search has to span every day instead of the currently selected one.
      if (newOrderType === 'future' && this.hour && this.hour.hour === 'ASAP') {
        this.selectFirstSchedulableSlot(this.selectedDayIndex)
      }
    },
  },
  computed: {
    // Only these two flows open with an explanation of why (the time passed, or was pushed back);
    // without this the dialog announces its title and the reason is never read.
    modalDescription() {
      return this.from === 'orderTimePassed' || this.from === 'needMoreTime' ? 'modal-desc' : null
    },
    ...mapState([
      'selectedStoreDays',
      'selectedDay',
      'selectedHour',
      'selectedService',
      'selectedStore',
      'dayAndTimeSelected',
      'buttonLoader',
      'orderData',
      'loggedIn',
      'branding',
      'cookies',
      'selectedAddress',
      'storeConfig',
      'customerData',
      'autoCompleteType',
    ]),
    visibleServices() {
      const services = this.selectedStore?.services
      if (!Array.isArray(services)) return []
      return services
        .filter((service) => service.is_visible)
        .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
    },
    firstNextDayIndex() {
      return this.selectedStoreDays[this.selectedDayIndex].hours.findIndex((hour) => hour.isNextDay)
    },
  },
  methods: {
    ...mapMutations([
      'SET_SELECTED_STORE_DAYS',
      'SET_SELECTED_DAY',
      'SET_SELECTED_HOUR',
      'SET_DAY_AND_TIME_SELECTED',
      'SET_ORDER_DATA',
      'SET_BUTTON_LOADER',
      'SET_TOASTER',
      'SET_LOGGED_IN',
      'SET_CUSTOMER_DATA',
      'SET_COOKIES',
      'SET_SELECTED_SERVICE',
      'SET_SELECTED_ADDRESS',
      'RESET_COOKIES',
      'SET_SELECTED_STORE',
      'SET_AUTO_COMPLETE_TYPE',
    ]),
    closeModal() {
      this.$emit('closeModal')
    },
    formatScheduleDayLabel(day, todayRef) {
      const date = displayShortDate(moment(day))
      const dayStr = moment(day).format('YYYY-MM-DD')
      const todayStr = todayRef
        ? moment(todayRef, ['MM/DD/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')
      const tomorrowStr = moment(todayStr, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (dayStr === todayStr) return this.t('storeModal.dateAndTime.today', { date })
      if (dayStr === tomorrowStr) return this.t('storeModal.dateAndTime.tomorrow', { date })
      const weekdayKey = moment(day, 'YYYY-MM-DD').format('dddd').toLowerCase()
      return this.t('storeModal.dateAndTime.dayWithDate', { day: this.t(`homeview.days.${weekdayKey}`), date })
    },
    selectAnotherLocationClicked() {
      this.$emit('closeModal')
      this.$router.push({ name: 'HomeView' })
    },
    toggleServiceTypeList() {
      this.serviceTypeListIsVisible = !this.serviceTypeListIsVisible
    },
    changeService(service) {
      // Backup current address if switching from address-requiring service
      if (this.selectedServiceData && this.selectedServiceData.requires_address) {
        this.deliveryAddressBackup = this.selectedAddress
        this.deliveryAptSuiteBackup = this.aptSuite
      }
      if (service.requires_address) {
        if (this.deliveryAddressBackup) {
          // Restore from backup
          this.SET_SELECTED_ADDRESS(this.deliveryAddressBackup)
          this.address = this.deliveryAddressBackup.address1 || ''
          this.aptSuite = this.deliveryAptSuiteBackup || ''
          this.addressInputIsVisible = false
          this.addressSelected = true

          // Reconstruct addressData for validation
          if (this.deliveryAddressBackup) {
            this.addressData = {
              street_number: this.deliveryAddressBackup.street_number || '',
              postal_code: this.deliveryAddressBackup.postal_code || '',
              address1: this.deliveryAddressBackup.address1 || '',
              address2: this.deliveryAddressBackup.address2 || '',
              city: this.deliveryAddressBackup.city || '',
              state_code: this.deliveryAddressBackup.state_code || '',
              phone: this.deliveryAddressBackup.phone || '',
              return_details: 'test',
            }
          }
        } else {
          // No backup available, clear address fields
          this.SET_SELECTED_ADDRESS(null)
          this.address = ''
          this.aptSuite = ''
          this.addressInputIsVisible = true
          this.addressSelected = false
          this.addressData = null
        }
      } else {
        // Non-address-requiring service
        this.addressInputIsVisible = false
        this.addressData = null
      }
      this.error = { status: false, message: '' }
      this.serviceTypeListIsVisible = false
      this.selectedServiceData = service
      this.validAddressError = null
      this.isStoreTemporarilyClosed = false
      this.getStoreDays()
    },
    getSelectedDayForPersistence() {
      // In ASAP scheduler mode, persist the day that actually contains ASAP.
      if (this.useASAPOrdersScheduler && this.selectedOrderType === 'ASAP') {
        const asapDay = this.selectedStoreDays.find((storeDay) => {
          return (storeDay.hours || []).some((hour) => hour.hour === 'ASAP')
        })

        if (asapDay) {
          return { ...asapDay }
        }
      }

      if (this.hour && this.hour.nextDayDate) {
        return {
          ...this.day,
          date: this.hour.nextDayDate,
          formatted: this.formatScheduleDayLabel(this.hour.nextDayDate, this.selectedStore.today),
        }
      }

      return this.day
    },
    addressValue(value) {
      if (value === '') {
        if (this.autoCompleteType == 'GOOGLE' && this.$refs.autoComplete) {
          this.$refs.autoComplete.resetInput()
        }
        if (this.autoCompleteType == 'RADAR' && this.$refs.radarAutoComplete) {
          this.$refs.radarAutoComplete.resetAddressInput()
        }
        this.selectedAddressLat = null
        this.selectedAddressLng = null
        this.validAddressError = null
        this.SET_SELECTED_ADDRESS(null)
      }
      this.address = value
    },
    changeAddressClicked() {
      this.addressInputIsVisible = true
      this.error = {
        status: false,
        message: '',
      }
      this.aptSuite = ''
      this.selectedAddressLat = null
      this.selectedAddressLng = null
      this.address = ''
      this.addressData = null
    },
    getLatAndLng(addressData) {
      this.getAddressComponents(addressData, false, true)
      if (this.validAddressError) {
        return
      }
      this.selectedAddressLat = addressData.geometry.location.lat()
      this.selectedAddressLng = addressData.geometry.location.lng()
    },
    async saveAddress() {
      this.SET_BUTTON_LOADER(true)
      let customerID = this.loggedIn ? localStorage.getItem('customerId') : localStorage.getItem('guestCustomerId')
      this.addressData.phone = this.customerData ? this.customerData.phone : null
      this.addressData.contact_phone = this.customerData ? this.customerData.phone : null
      this.addressData.address2 = this.aptSuite ? this.aptSuite : ''

      // Ensure latitude and longitude are included in the address data
      if (this.selectedAddressLat && this.selectedAddressLng) {
        this.addressData.latitude = this.selectedAddressLat
        this.addressData.longitude = this.selectedAddressLng
      }

      await customersApi
        .saveAddress(this.addressData, customerID)
        .then((response) => {
          localStorage.setItem('selectedAddress', JSON.stringify(response.data.data))
          this.SET_SELECTED_ADDRESS(response.data.data)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch(() => {
          this.SET_BUTTON_LOADER(false)
          let toasterData = {
            show: true,
            message: this.t('common.somethingWentWrongLater'),
          }
          this.SET_TOASTER(toasterData)
        })
    },
    changeLocation() {
      this.$emit('closeModal')
      this.$router.push({ name: 'HomeView' })
    },
    hasSchedulableHours(day) {
      return (day?.hours || []).some((hour) => hour.hour !== 'ASAP')
    },
    // Locates the first real (non-ASAP) slot, preferring `preferredDayIndex` and then
    // falling forward through the following days before wrapping to the earlier ones.
    findFirstSchedulableSlot(preferredDayIndex = 0) {
      const days = this.selectedStoreDays || []
      const startIndex = preferredDayIndex > 0 && preferredDayIndex < days.length ? preferredDayIndex : 0
      for (let offset = 0; offset < days.length; offset++) {
        const dayIndex = (startIndex + offset) % days.length
        const hourIndex = (days[dayIndex].hours || []).findIndex((hour) => hour.hour !== 'ASAP')
        if (hourIndex !== -1) {
          return { dayIndex, hourIndex }
        }
      }
      return null
    },
    // Moves the day/hour selection onto the first schedulable slot. When the store has no
    // schedulable slot at all, future ordering is turned off and we fall back to ASAP so a
    // ready_ts can never be built out of the 'ASAP' pseudo-slot. Returns true on success.
    selectFirstSchedulableSlot(preferredDayIndex = this.selectedDayIndex) {
      const slot = this.findFirstSchedulableSlot(preferredDayIndex)
      if (!slot) {
        this.isFutureAvailable = false
        if (this.isAsapAvailable) {
          this.selectedOrderType = 'ASAP'
        }
        return false
      }
      this.selectedDayIndex = slot.dayIndex
      this.day = this.selectedStoreDays[slot.dayIndex]
      this.selectedHourIndex = slot.hourIndex
      this.hour = this.selectedStoreDays[slot.dayIndex].hours[slot.hourIndex]
      return true
    },
    selectDay(index) {
      this.day = this.selectedStoreDays[index]
      this.selectedDayIndex = index
      const selectedDayHours = this.selectedStoreDays[index].hours || []

      // In non-scheduler mode, always default to the first available slot.
      // This restores ASAP when users return to the first day and ASAP exists.
      if (!this.useASAPOrdersScheduler) {
        this.selectedHourIndex = 0
        this.hour = selectedDayHours[0] || null
      } else if (this.selectedOrderType === 'future') {
        // For future orders, find the first non-ASAP hour
        const firstNonAsapHourIndex = selectedDayHours.findIndex((hour) => hour.hour !== 'ASAP')
        if (firstNonAsapHourIndex !== -1) {
          this.selectedHourIndex = firstNonAsapHourIndex
          this.hour = selectedDayHours[firstNonAsapHourIndex]
        } else if (!this.selectFirstSchedulableSlot(index)) {
          // No schedulable slot anywhere - ASAP is all this store can offer right now
          this.selectedHourIndex = 0
          this.hour = selectedDayHours[0] || null
        }
      } else {
        // For ASAP orders, use the first hour (which should be ASAP)
        this.selectedHourIndex = 0
        this.hour = selectedDayHours[0] || null
      }

      this.toggleDayDropdown()
    },
    selectHour(index) {
      this.selectedHourIndex = index
      this.hour = this.day.hours[index]
      this.toggleHourDropdown()
    },
    toggleDayDropdown() {
      this.dayDropdownIsOpen = !this.dayDropdownIsOpen
      if (this.dayDropdownIsOpen) {
        this.$nextTick(() => {
          this.scrollToSelectedDay()
        })
      }
    },
    scrollToSelectedDay() {
      const dayDropdownRef = this.$refs.dayDropdown
      if (!dayDropdownRef) {
        return
      }

      const dropdownElement = dayDropdownRef.querySelector('.dropdown')
      const selectedDayElement = dayDropdownRef.querySelector(`[data-day-index="${this.selectedDayIndex}"]`)

      if (!dropdownElement || !selectedDayElement) {
        return
      }

      const targetScrollTop =
        selectedDayElement.offsetTop - dropdownElement.clientHeight / 2 + selectedDayElement.clientHeight / 2

      dropdownElement.scrollTop = Math.max(targetScrollTop, 0)
    },
    toggleHourDropdown() {
      this.hourDropdownIsOpen = !this.hourDropdownIsOpen
      if (this.hourDropdownIsOpen) {
        this.$nextTick(() => {
          this.scrollToSelectedHour()
        })
      }
    },
    scrollToSelectedHour() {
      const hourDropdownRef = this.$refs.hourDropdown
      if (!hourDropdownRef) {
        return
      }

      const dropdownElement = hourDropdownRef.querySelector('.dropdown')
      const selectedHourElement = hourDropdownRef.querySelector(`[data-hour-index="${this.selectedHourIndex}"]`)

      if (!dropdownElement || !selectedHourElement) {
        return
      }

      const targetScrollTop =
        selectedHourElement.offsetTop - dropdownElement.clientHeight / 2 + selectedHourElement.clientHeight / 2

      dropdownElement.scrollTop = Math.max(targetScrollTop, 0)
    },
    logOut() {
      customersApi
        .logout()
        .then((response) => {
          if (response.data.data.ok == 'Logged out') {
            this.SET_LOGGED_IN(false)
            this.SET_ORDER_DATA(null)
            localStorage.removeItem('customerId')
            localStorage.removeItem('orderId')
            localStorage.removeItem('selectedTip')
            localStorage.removeItem('dayAndTimeSelected')
            localStorage.removeItem('auth')
            localStorage.removeItem('loggedIn')
            localStorage.removeItem('phoneVerified')
            localStorage.removeItem('newCardData')
            localStorage.removeItem('otherTipAmount')
            this.RESET_COOKIES()
            this.SET_DAY_AND_TIME_SELECTED(false)
            this.SET_CUSTOMER_DATA(null)
            this.$router.push('/')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // A 'future' order type sitting on the ASAP pseudo-slot would build a ready_ts like
    // "2026-08-26 ASAP" and fail server-side. That state means the store has nothing
    // schedulable left today, so submit it as the ASAP order it really is.
    normalizeOrderTypeBeforeSubmit() {
      if (this.useASAPOrdersScheduler && this.selectedOrderType !== 'ASAP' && this.hour?.hour === 'ASAP') {
        this.selectedOrderType = 'ASAP'
      }
    },
    createOrder() {
      this.normalizeOrderTypeBeforeSubmit()
      localStorage.setItem('selectedOrderType', this.selectedOrderType)
      this.SET_BUTTON_LOADER(true)
      let serviceTypeId = this.selectedServiceData
        ? this.selectedServiceData.service_type_id
        : localStorage.getItem('selectedServiceId')
      const isAsap = this.useASAPOrdersScheduler ? this.selectedOrderType == 'ASAP' : this.hour.hour == 'ASAP'
      const requiresAddress = this.selectedServiceData
        ? this.selectedServiceData.requires_address
        : this.selectedService.requires_address
      let payload = buildOrderPayload({
        customerId: this.loggedIn ? localStorage.getItem('customerId') : localStorage.getItem('guestCustomerId'),
        storeId: this.selectedStore.store_id,
        serviceTypeId,
        service: { ...this.selectedServiceData, requires_address: requiresAddress },
        day: this.day,
        hour: this.hour,
        isAsap,
        guestCount: this.guestCount,
        discountCode: localStorage.getItem('discountCode'),
        addressId: requiresAddress ? JSON.parse(localStorage.getItem('selectedAddress')).address_id : null,
      })
      ordersApi
        .createOrder(payload)
        .then((response) => {
          // Don't modify this.day.date and this.day.formatted here
          // The original day selection should remain intact for modal restoration
          this.SET_BUTTON_LOADER(false)
          localStorage.setItem('orderId', response.data.data.order.order_id)
          this.SET_ORDER_DATA(response.data.data)
          localStorage.setItem('dayAndTimeSelected', true)
          this.SET_DAY_AND_TIME_SELECTED(true)

          let dayToSet = this.getSelectedDayForPersistence()
          this.SET_SELECTED_DAY(dayToSet)
          localStorage.setItem('selectedDay', JSON.stringify(dayToSet))
          if (this.selectedOrderType == 'ASAP') {
            let restaurantCurrentTimeWithTimezone = moment().utcOffset(this.timeZoneOffset).format('HH:mm')
            let selectedHour = {
              hour: 'ASAP',
              asapTime: restaurantCurrentTimeWithTimezone,
              formatted: 'ASAP',
            }
            this.SET_SELECTED_HOUR(selectedHour)
            localStorage.setItem('selectedHour', JSON.stringify(selectedHour))
          } else {
            this.SET_SELECTED_HOUR(this.hour)
            localStorage.setItem('selectedHour', JSON.stringify(this.hour))
          }
          this.SET_COOKIES(response.data.cookies)
          this.SET_SELECTED_SERVICE(this.selectedServiceData)
          localStorage.setItem('selectedServiceId', this.selectedServiceData.service_type_id)
          localStorage.removeItem('discountCode')
          if (response.data.data.pending_discounts) {
            this.$emit('openDiscountModal', response.data.data.pending_discounts)
          }
          let deepLinkItemId = localStorage.getItem('deepLinkItemId')
          if (deepLinkItemId) {
            this.$emit('addDeepLinkItemToCart')
          }
          this.closeModal()
        })
        .catch((error) => {
          console.log(error)
          this.SET_BUTTON_LOADER(false)
          if (error?.response?.data?.status == 403) {
            let toasterData = {
              show: true,
              message: this.t('common.sessionExpired'),
            }
            this.SET_TOASTER(toasterData)
            this.logOut()
            return
          }
          this.error.status = true
          this.error.message =
            error?.response?.data?.data?.error || this.t('common.somethingWentWrongLater')
        })
    },
    async updateGuestCount() {
      let payload = {
        order: {
          guest_count: this.guestCount,
        },
      }
      try {
        const guestCountResponse = await ordersApi.updateOrderWithPut(this.orderData.order.order_id, payload)
        this.SET_ORDER_DATA(guestCountResponse.data.data)
        this.SET_COOKIES(guestCountResponse.data.cookies)
      } catch (error) {
        console.log(error)
      }
    },
    updateOrder() {
      this.normalizeOrderTypeBeforeSubmit()
      localStorage.setItem('selectedOrderType', this.selectedOrderType)
      this.SET_BUTTON_LOADER(true)
      let serviceTypeId = this.selectedServiceData
        ? this.selectedServiceData.service_type_id
        : localStorage.getItem('selectedServiceId')
      const isAsap = this.useASAPOrdersScheduler ? this.selectedOrderType == 'ASAP' : this.hour.hour == 'ASAP'
      let storedAddress = null
      if (this.selectedServiceData.requires_address) {
        storedAddress = JSON.parse(localStorage.getItem('selectedAddress'))
      }
      let payload = buildOrderPayload({
        customerId: this.loggedIn ? localStorage.getItem('customerId') : localStorage.getItem('guestCustomerId'),
        storeId: this.selectedStore.store_id,
        serviceTypeId,
        service: this.selectedServiceData,
        day: this.day,
        hour: this.hour,
        isAsap,
        orderId: this.orderData.order.order_id,
        guestCount: this.guestCount,
        addressId: storedAddress ? storedAddress.address_id : this.selectedAddress?.address_id,
      })
      ordersApi
        .updateOrder(payload)
        .then(async (response) => {
          // Don't modify this.day.date and this.day.formatted here
          // The original day selection should remain intact for modal restoration
          this.SET_ORDER_DATA(response.data.data)
          this.SET_COOKIES(response.data.cookies)

          if (this.selectedServiceData.requires_guest_count) {
            if (Number(response?.data?.data?.order?.guest_count) !== Number(this.guestCount)) {
              await this.updateGuestCount()
            }
          }

          let dayToSet = this.getSelectedDayForPersistence()
          this.SET_SELECTED_DAY(dayToSet)
          localStorage.setItem('selectedDay', JSON.stringify(dayToSet))
          if (this.selectedOrderType == 'ASAP') {
            let restaurantCurrentTimeWithTimezone = moment().utcOffset(this.timeZoneOffset).format('HH:mm')
            let selectedHour = {
              hour: 'ASAP',
              asapTime: restaurantCurrentTimeWithTimezone,
              formatted: 'ASAP',
            }
            this.SET_SELECTED_HOUR(selectedHour)
            localStorage.setItem('selectedHour', JSON.stringify(selectedHour))
          } else {
            this.SET_SELECTED_HOUR(this.hour)
            localStorage.setItem('selectedHour', JSON.stringify(this.hour))
          }
          this.SET_SELECTED_SERVICE(this.selectedServiceData)
          localStorage.setItem('selectedServiceId', this.selectedServiceData.service_type_id)
          if (this.from == 'orderTimePassed' || this.from == 'needMoreTime') {
            this.$emit('placeOrder', 'dateTimeModal')
          }
          await this.revalidateCoupons()
          this.SET_BUTTON_LOADER(false)
          this.closeModal()
        })
        .catch((error) => {
          console.log(error)
          this.SET_BUTTON_LOADER(false)
          if (error?.response?.data?.status == 403) {
            let toasterData = {
              show: true,
              message: this.t('common.sessionExpired'),
            }
            this.SET_TOASTER(toasterData)
            this.logOut()
            return
          }
          this.error.status = true
          this.error.message =
            error?.response?.data?.data?.error || this.t('common.somethingWentWrongLater')
        })
    },
    async buttonClicked() {
      // If store is temporarily closed, navigate to home view
      if (this.isStoreTemporarilyClosed) {
        this.closeModal()
        this.$router.push({ name: 'HomeView' })
        return
      }

      // validate the input fields
      this.v$.$touch()
      if (this.v$.$error) return
      if (
        (this.selectedServiceData.requires_address && !this.selectedAddress) ||
        (this.selectedServiceData.requires_address && this.addressInputIsVisible)
      ) {
        // check if the address is selected from the suggested list
        if (!this.addressData) {
          this.addressSelected = false
        }
        if (!this.addressSelected) {
          if (!this.addressSelected) {
            this.addressSelected = false
          }
          return
        }
      }
      if (!this.loggedIn) {
        // guest login
        await this.guestCustomerLogin()
      } else {
        // Verify logged in customer ID exists
        if (!localStorage.getItem('customerId')) {
          let toasterData = {
            show: true,
            message: this.t('common.sessionExpired'),
          }
          this.SET_TOASTER(toasterData)
          this.closeModal()
          this.logOut()
          return
        }
      }
      if (this.selectedServiceData.requires_address) {
        if (!this.selectedAddress || this.addressInputIsVisible) {
          await this.saveAddress()
        }
        let response = await this.getDeliveryInfo()
        if (response.error) {
          this.error.status = true
          this.error.message = response.error
          this.error.link = response.link
          this.SET_BUTTON_LOADER(false)
          return
        }
      }
      if (this.dayAndTimeSelected) {
        this.updateOrder()
      } else {
        this.createOrder()
      }
      this.getStore()
      this.$emit('confirmedDate')
    },
    async revalidateCoupons() {
      if (!this.loggedIn) return

      const coupons = this.orderData?.coupons
      if (!coupons?.length) return

      const promoCodeCoupons = coupons.filter((c) => !c.is_loyalty && !c.is_bank_reward && c.clu)
      if (!promoCodeCoupons.length) return

      const orderId = this.orderData.order.order_id
      const customerId = parseInt(localStorage.getItem('customerId'))

      for (const coupon of promoCodeCoupons) {
        try {
          const removeResponse = await ordersApi.removeDiscount(orderId, {
            customer_id: customerId,
            discount_id: parseInt(coupon.coupon_id),
          })

          try {
            const redeemResponse = await ordersApi.redeemPromoCode(orderId, {
              customer_id: customerId,
              discount_code: coupon.clu,
            })

            if (redeemResponse.data.data.errors?.length) {
              this.SET_ORDER_DATA(removeResponse.data.data)
              this.SET_COOKIES(removeResponse.data.cookies)
              this.SET_TOASTER({
                show: true,
                message: this.t('storeModal.dateAndTime.couponInvalidForTime', { name: coupon.name }),
              })
            } else {
              this.SET_ORDER_DATA(redeemResponse.data.data)
              this.SET_COOKIES(redeemResponse.data.cookies)
            }
          } catch {
            this.SET_ORDER_DATA(removeResponse.data.data)
            this.SET_COOKIES(removeResponse.data.cookies)
            this.SET_TOASTER({
              show: true,
              message: this.t('storeModal.dateAndTime.couponInvalidForTime', { name: coupon.name }),
            })
          }
        } catch (e) {
          console.log('Coupon revalidation failed:', e)
        }
      }
    },
    getStore() {
      let payload = {
        service_schedule: true,
        service_type_id: this.selectedServiceData.service_type_id,
      }
      storesApi
        .getStore(this.selectedStore.store_id, payload)
        .then((response) => {
          this.SET_SELECTED_STORE(response.data.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async guestCustomerLogin() {
      this.SET_BUTTON_LOADER(true)
      await customersApi
        .guestLogin()
        .then((response) => {
          if (response.data.data.ok == true) {
            localStorage.setItem('guestCustomerId', response.data.data.customer_id)
            this.SET_COOKIES(response.data.cookies)
            this.SET_CUSTOMER_DATA(response.data.data)
          }
        })
        .catch((error) => {
          this.SET_BUTTON_LOADER(false)
          console.log(error)
        })
    },
    // Mirrors the `visibleServices` computed so a persisted default can only ever be a
    // service the picker would have offered.
    pickDefaultStoreService(services) {
      if (!Array.isArray(services)) return null
      return (
        services
          .filter((service) => service.is_visible)
          .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))[0] || null
      )
    },
    getStoreServices() {
      let storeId = this.$route.params.storeId || this.storeId
      storesApi
        .getStore(storeId)
        .then((response) => {
          if (response?.data?.data?.fraud_detection_gateways[0]?.payproc_id === 28) {
            let merchantId = response?.data?.data?.fraud_detection_gateways[0]?.extra?.merchant_id
            if (merchantId) {
              localStorage.setItem('merchantId', merchantId)
              this.$store.dispatch('setFraudSessionID')
            }
          }
          // `getStore` is called without a service filter, so `services` includes services
          // the picker hides (Dine-In is enabled chain-wide but only used for in-store
          // loyalty orders). Defaulting to services[0] could therefore select a service the
          // user was never shown, so the default must come from the visible set only.
          const services = response.data.data.services
          const selectedServiceTypeId = localStorage.getItem('selectedServiceId')
          const storedService = selectedServiceTypeId
            ? services.find((service) => service.service_type_id == selectedServiceTypeId)
            : null

          if (storedService) {
            this.selectedServiceData = storedService
          } else {
            const defaultService = this.pickDefaultStoreService(services)
            // A store with no visible service cannot be ordered from; leave the selection
            // untouched rather than persisting a hidden service type.
            if (defaultService) {
              this.selectedServiceData = defaultService
              this.SET_SELECTED_SERVICE(defaultService)
              localStorage.setItem('selectedServiceId', defaultService.service_type_id)
              localStorage.setItem('selectedServiceData', JSON.stringify(defaultService))
              localStorage.setItem('timeZoneOffset', response.data.data.timezone_offset_mins)
            }
          }
          this.getStoreDays()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getDeliveryInfo() {
      this.SET_BUTTON_LOADER(true)
      let responseData
      let serviceTypeId = this.selectedServiceData
        ? this.selectedServiceData.service_type_id
        : localStorage.getItem('selectedServiceId')

      // Use selectedAddress coordinates if available, otherwise use the newly selected coordinates
      let latitude = this.selectedAddress?.latitude || this.selectedAddressLat || this.addressData?.latitude
      let longitude = this.selectedAddress?.longitude || this.selectedAddressLng || this.addressData?.longitude

      let payload = {
        service_schedule: true,
        service_type_id: serviceTypeId,
        latitude: latitude,
        longitude: longitude,
        store_id: this.$route.params.storeId || this.storeId,
      }
      await storesApi
        .getStore(null, payload)
        .then((response) => {
          responseData = response.data.data[0]
          if (response.data.data[0].delivery_info) {
            localStorage.setItem('deliveryInfo', JSON.stringify(response.data.data[0].delivery_info))
          }
        })
        .catch((error) => {
          if (error.response.data.data.error == 'no stores found') {
            responseData = {
              error:
                this.t('storeModal.dateAndTime.deliveryAreaError'),
              link: true,
            }
          } else {
            responseData = error.response.data.data
          }
        })
      return responseData
    },
    getStoreDays() {
      let serviceTypeId = this.selectedServiceData
        ? this.selectedServiceData.service_type_id
        : localStorage.getItem('selectedServiceId')
      let payload = {
        service_schedule: true,
        service_type_id: serviceTypeId,
      }
      storesApi
        .getStore(this.$route.params.storeId || this.storeId, payload)
        .then((response) => {
          let serviceData = response.data.data
          let today = response.data.data.today
          let timeZoneOffset = response.data.data.timezone_offset_mins
          this.timeZoneOffset = timeZoneOffset

          // Check if service_schedule is empty for the selected service type
          if (
            !serviceData.service_schedule ||
            !serviceData.service_schedule[serviceTypeId] ||
            Object.keys(serviceData.service_schedule[serviceTypeId]).length === 0 ||
            Object.values(serviceData.service_schedule[serviceTypeId]).every((day) => day.length === 0)
          ) {
            this.isStoreTemporarilyClosed = true
            this.SET_SELECTED_STORE_DAYS([])
            return
          }

          this.isStoreTemporarilyClosed = false
          if (this.useASAPOrdersScheduler === true) {
            this.getDayAndHoursForOrderType(serviceData, serviceTypeId, today, timeZoneOffset)
          } else {
            this.getDaysAndHours(serviceData, serviceTypeId, today, timeZoneOffset)
          }
          if (response.data.data.delivery_info) {
            localStorage.setItem('deliveryInfo', JSON.stringify(response.data.data.delivery_info))
          }
          localStorage.setItem('timeZoneOffset', response.data.data.timezone_offset_mins)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
          // Only show error message if it's not a case of empty service schedule
          if (!this.isStoreTemporarilyClosed) {
            let toasterData = {
              show: true,
              message: this.t('common.somethingWentWrongLater'),
            }
            this.SET_TOASTER(toasterData)
          }
        })
    },
    getDayAndHoursForOrderType(serviceData, serviceTypeId, today, timeZoneOffset) {
      let availableHoursList = []
      let isAsapAvailable = false
      let savedOrderType = localStorage.getItem('selectedOrderType')
      if (
        typeof serviceData.service_schedule[serviceTypeId] === 'undefined' ||
        Object.keys(serviceData.service_schedule[serviceTypeId]).length === 0 ||
        Object.values(serviceData.service_schedule[serviceTypeId]).every((day) => day.length === 0)
      ) {
        this.isStoreTemporarilyClosed = true
        this.SET_SELECTED_STORE_DAYS([])
        return null
      }

      let selectedService =
        this.selectedServiceData ||
        this.selectedStore.services.find(
          (service) => service.service_type_id == localStorage.getItem('selectedServiceId')
        )

      let prepTime = selectedService?.base_prep_time || 0
      let leadTime = selectedService?.lead_time || 0
      let currentMinutes =
        moment().utcOffset(timeZoneOffset).minutes() + moment().utcOffset(timeZoneOffset).hours() * 60

      Object.entries(serviceData.service_schedule[serviceTypeId]).forEach(([day, v_list]) => {
        if (v_list.length == 0) {
          delete serviceData.service_schedule[serviceTypeId][day]
        }
        v_list.forEach((hourRange) => {
          if (hourRange[1] > 1440) {
            if (moment(day).isBefore(moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD'))) {
              let nextDay = moment(day, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
              if (typeof serviceData.service_schedule[serviceTypeId][nextDay] === 'undefined') {
                serviceData.service_schedule[serviceTypeId][nextDay] = []
              }
              serviceData.service_schedule[serviceTypeId][nextDay].unshift([
                hourRange[0] - 24 * 60,
                hourRange[1] - 24 * 60,
              ])
              // hourRange[1] = 1440
            }
          }
        })
      })
      Object.entries(serviceData.service_schedule[serviceTypeId]).forEach(([day, v_list]) => {
        if (moment(day, 'YYYY-MM-DD').isBefore(moment(today, 'MM/DD/YYYY'), 'day')) {
          return
        }
        var hours = []
        v_list.forEach((hourRange) => {
          let endTime = hourRange[1]
          if (endTime !== 1440) {
            endTime -= 15
          } else {
            endTime = 1435
          }
          for (var hr = hourRange[0]; hr <= endTime; hr += 15) {
            let militaryTime = this.calculateTimeToHour(hr)
            let isNextDay = false
            let nextDayDate = null
            if (hr >= 1440) {
              militaryTime = this.calculateTimeToHour(hr - 1440)
              isNextDay = true
              nextDayDate = moment(day, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
            }
            hours.push({
              hour: militaryTime,
              formatted: displayTime(moment(militaryTime, 'HH:mm')),
              originalHour: hr,
              isNextDay: isNextDay,
              nextDayDate: nextDayDate,
            })
          }
        })
        hours.sort((a, b) => a.originalHour - b.originalHour)
        availableHoursList.push({
          date: day,
          formatted: this.formatScheduleDayLabel(day, today),
          hours: hours,
        })
      })

      let currentPlusPrepTime = currentMinutes + prepTime

      let todayKey = moment().format('YYYY-MM-DD')
      let yesterdayKey = moment().subtract(1, 'days').format('YYYY-MM-DD')
      let todaySchedule = serviceData.service_schedule[serviceTypeId][todayKey] || []
      let yesterdaySchedule = serviceData.service_schedule[serviceTypeId][yesterdayKey] || []
      let yesterdayClosingTime = (yesterdaySchedule[0]?.[1] || -1) - 1440
      let yesterdayStartingTime = (yesterdaySchedule[0]?.[0] || -1) - 1440
      let todayClosingTime = todaySchedule[0]?.[1] || -1
      let todayStartingTime = todaySchedule[0]?.[0] || -1

      let asapAvailable = false
      // Check if delivery_provider_grace_period is enabled and has a value > 0
      const gracePeriod = this.storeConfig?.delivery_provider_grace_period || 0

      if (yesterdaySchedule.length > 0) {
        if (yesterdayStartingTime - leadTime <= currentPlusPrepTime && currentPlusPrepTime <= yesterdayClosingTime) {
          asapAvailable = true
        }
      } else {
        if (todayStartingTime - leadTime <= currentPlusPrepTime && currentPlusPrepTime <= todayClosingTime) {
          asapAvailable = true
        }
      }

      // For delivery service types, only show ASAP if grace period is enabled AND existing conditions are met
      if (this.selectedServiceData && this.selectedServiceData.requires_address && gracePeriod > 0) {
        asapAvailable = true
      }

      // Feature flag: disable ASAP if lead time > 60 min
      if (this.disableAsapOnHighLeadTime && leadTime > 60) {
        asapAvailable = false
      }

      const todayDateStr = moment().utcOffset(timeZoneOffset).format('YYYY-MM-DD')
      let todayEntry = availableHoursList.find((d) => d.date === todayDateStr)

      // If the schedule didn't return an entry for today at all (e.g. the remaining window
      // is too short to fit a 15-min slot, so the API omits it), synthesize one so ASAP can
      // still be offered when it's available (schedule window match or grace period override).
      if (!todayEntry && this.selectedStore.is_open && asapAvailable) {
        todayEntry = {
          date: todayDateStr,
          formatted: this.formatScheduleDayLabel(todayDateStr, todayDateStr),
          hours: [],
        }
        availableHoursList.push(todayEntry)
      }

      if (todayEntry) {
        if (this.selectedStore.is_open && asapAvailable) {
          isAsapAvailable = true
          this.selectedOrderType = 'ASAP'

          const { showClosingSoonMessage, timeLeft } = this.checkClosingSoonForASAP(
            leadTime,
            prepTime,
            currentMinutes,
            yesterdayClosingTime,
            todayClosingTime
          )

          if (showClosingSoonMessage) {
            this.showClosingSoonMessage(timeLeft)
          }
          let restaurantCurrentTimeWithTimezone = moment().utcOffset(timeZoneOffset).format('HH:mm')

          todayEntry.hours.unshift({
            hour: 'ASAP',
            asapTime: restaurantCurrentTimeWithTimezone,
            formatted: 'ASAP',
          })
        } else if (todayEntry.hours.length === 0) {
          // Nothing to offer today (no remaining slots and ASAP not available) - drop it
          availableHoursList = availableHoursList.filter((d) => d.date !== todayDateStr)
        }
      }

      this.isAsapAvailable = isAsapAvailable

      // Future ordering needs at least one real slot. When the store closes within the lead
      // time, the only entry left can be today's ASAP pseudo-slot - offering this.t('storeModal.dateAndTime.futureOrder')
      // there leaves the time picker empty and produces an invalid ready_ts.
      const hasSchedulableSlot = availableHoursList.some((day) =>
        (day.hours || []).some((hour) => hour.hour !== 'ASAP')
      )
      this.isFutureAvailable = hasSchedulableSlot

      if (savedOrderType === 'future' && hasSchedulableSlot) {
        this.selectedOrderType = 'future'
      } else {
        this.selectedOrderType = isAsapAvailable ? 'ASAP' : 'future'
      }
      availableHoursList.sort((a, b) => {
        return moment(a.date).diff(moment(b.date))
      })
      if (this.storeConfig?.disable_future_orders) {
        this.isFutureAvailable = false
        this.isAsapAvailable = true
        this.selectedOrderType = 'ASAP'
      }
      this.SET_SELECTED_STORE_DAYS(availableHoursList)
      localStorage.setItem('selectedStoreDays', JSON.stringify(availableHoursList))

      // Check if no available hours after processing
      if (availableHoursList.length === 0 || availableHoursList.every((day) => day.hours.length === 0)) {
        this.isStoreTemporarilyClosed = true
        this.SET_SELECTED_STORE_DAYS([])
        return
      }
      if (this.selectedStoreDays && !this.dayAndTimeSelected) {
        this.selectedDayIndex = 0
        this.day = this.selectedStoreDays[0]

        // For future orders land on the first schedulable slot, which may live on a later day
        // when today only carries ASAP. Otherwise use the first hour (ASAP when available).
        if (this.selectedOrderType !== 'future' || !this.selectFirstSchedulableSlot(0)) {
          this.hour = this.selectedStoreDays[this.selectedDayIndex].hours[0]
          this.selectedHourIndex = 0
        }
      } else {
        // find the index of the selected day
        this.selectedDayIndex = this.selectedStoreDays.findIndex((day) => day.date === this.selectedDay.date)
        if (this.selectedDayIndex == -1) {
          this.selectedDayIndex = 0
        }
        // find the index of the selected hour
        try {
          this.selectedHourIndex = this.selectedStoreDays[this.selectedDayIndex].hours.findIndex(
            (hour) => hour.hour === this.selectedHour.hour
          )
          this.day = this.selectedStoreDays[this.selectedDayIndex]
        } catch (error) {
          this.selectedHourIndex = -1
        }
        if (this.selectedHourIndex == -1) {
          this.hour = this.selectedStoreDays[this.selectedDayIndex].hours[0]
          this.selectedHourIndex = 0
        } else {
          this.hour = this.selectedStoreDays[this.selectedDayIndex].hours[this.selectedHourIndex]
        }
        if (this.selectedHour.isNextDay) {
          // Adjust the day to the previous day
          const previousDayIndex = this.selectedDayIndex - 1
          if (previousDayIndex >= 0) {
            this.selectedDayIndex = previousDayIndex
            this.day = this.selectedStoreDays[previousDayIndex]
            this.hour = this.selectedHour
            this.selectedHourIndex = this.selectedStoreDays[previousDayIndex].hours.findIndex(
              (hour) => hour.hour === this.selectedHour.hour
            )
          }
        }
      }

      // Restoring a previous selection can also land 'future' on the ASAP pseudo-slot, so
      // re-point it at a real slot (or fall back to ASAP when the store has none left).
      if (this.useASAPOrdersScheduler && this.selectedOrderType === 'future' && this.hour?.hour === 'ASAP') {
        this.selectFirstSchedulableSlot(this.selectedDayIndex)
      }
    },
    getDaysAndHours(serviceData, serviceTypeId, today, timeZoneOffset) {
      let availableHoursList = []
      // find the restaurants current time in military time
      let restaurantCurrentTimeWithTimezone = moment().utcOffset(timeZoneOffset).format('HH:mm')

      let selectedService =
        this.selectedServiceData ||
        this.selectedStore.services.find(
          (service) => service.service_type_id == localStorage.getItem('selectedServiceId')
        )

      let prepTime = selectedService?.base_prep_time || 0
      let leadTime = selectedService?.lead_time || 0
      let currentMinutes =
        moment().utcOffset(timeZoneOffset).minutes() + moment().utcOffset(timeZoneOffset).hours() * 60

      if (
        typeof serviceData.service_schedule[serviceTypeId] === 'undefined' ||
        Object.keys(serviceData.service_schedule[serviceTypeId]).length === 0 ||
        Object.values(serviceData.service_schedule[serviceTypeId]).every((day) => day.length === 0)
      ) {
        this.isStoreTemporarilyClosed = true
        this.SET_SELECTED_STORE_DAYS([])
        return null
      }
      Object.entries(serviceData.service_schedule[serviceTypeId]).forEach(([day, v_list]) => {
        if (v_list.length == 0) {
          delete serviceData.service_schedule[serviceTypeId][day]
        }
        // if any of the v_list is 1440 or more, add it to the next day.
        v_list.forEach((hourRange) => {
          if (hourRange[1] > 1440) {
            if (moment(day).isBefore(moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD'))) {
              let nextDay = moment(day, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')

              if (typeof serviceData.service_schedule[serviceTypeId][nextDay] === 'undefined') {
                serviceData.service_schedule[serviceTypeId][nextDay] = []
              }
              serviceData.service_schedule[serviceTypeId][nextDay].unshift([
                hourRange[0] - 24 * 60,
                hourRange[1] - 24 * 60,
              ])
              //hourRange[1] = 1440
            }
          }
        })
      })
      Object.entries(serviceData.service_schedule[serviceTypeId]).forEach(([day, v_list]) => {
        // if day is before today then skip
        if (moment(day, 'YYYY-MM-DD').isBefore(moment(today, 'MM/DD/YYYY'), 'day')) {
          return
        }
        // get the hours for the day
        var hours = []
        v_list.forEach((hourRange) => {
          // Subtract 15 minutes from the end time if it's not the end of a day
          let endTime = hourRange[1]
          if (endTime !== 1440) {
            endTime -= 15
          } else {
            endTime = 1435
          }

          for (var hr = hourRange[0]; hr <= endTime; hr += 15) {
            let militaryTime = this.calculateTimeToHour(hr)
            let isNextDay = false
            let nextDayDate = null
            if (hr >= 1440) {
              militaryTime = this.calculateTimeToHour(hr - 1440)
              isNextDay = true
              nextDayDate = moment(day, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
            }
            hours.push({
              hour: militaryTime,
              formatted: displayTime(moment(militaryTime, 'HH:mm')),
              originalHour: hr,
              isNextDay: isNextDay,
              nextDayDate: nextDayDate,
            })
          }
        })

        hours.sort((a, b) => a.originalHour - b.originalHour)
        availableHoursList.push({
          date: day,
          formatted: this.formatScheduleDayLabel(day, today),
          hours: hours,
        })
      })

      let currentPlusPrepTime = currentMinutes + prepTime

      let todayKey = moment().format('YYYY-MM-DD')
      let yesterdayKey = moment().subtract(1, 'days').format('YYYY-MM-DD')

      let todaySchedule = serviceData.service_schedule[serviceTypeId][todayKey] || []
      let yesterdaySchedule = serviceData.service_schedule[serviceTypeId][yesterdayKey] || []

      let yesterdayClosingTime = (yesterdaySchedule[0]?.[1] || -1) - 1440
      let yesterdayStartingTime = (yesterdaySchedule[0]?.[0] || -1) - 1440
      let todayClosingTime = todaySchedule[0]?.[1] || -1
      let todayStartingTime = todaySchedule[0]?.[0] || -1

      let asapAvailable = false
      // Check if delivery_provider_grace_period is enabled and has a value > 0
      const gracePeriod = this.storeConfig?.delivery_provider_grace_period || 0

      if (yesterdaySchedule.length > 0) {
        if (yesterdayStartingTime - leadTime <= currentPlusPrepTime && currentPlusPrepTime <= yesterdayClosingTime) {
          asapAvailable = true
        }
      } else {
        if (todayStartingTime - leadTime <= currentPlusPrepTime && currentPlusPrepTime <= todayClosingTime) {
          asapAvailable = true
        }
      }

      // For delivery service types, only show ASAP if grace period is enabled AND existing conditions are met
      if (this.selectedServiceData && this.selectedServiceData.requires_address && gracePeriod > 0) {
        asapAvailable = true
      }

      // Feature flag: disable ASAP if lead time > 60 min
      if (this.disableAsapOnHighLeadTime && leadTime > 60) {
        asapAvailable = false
      }

      const todayDateStr = moment().utcOffset(timeZoneOffset).format('YYYY-MM-DD')
      let todayEntry = availableHoursList.find((d) => d.date === todayDateStr)

      // If the schedule didn't return an entry for today at all (e.g. the remaining window
      // is too short to fit a 15-min slot, so the API omits it), synthesize one so ASAP can
      // still be offered when it's available (schedule window match or grace period override).
      if (!todayEntry && this.selectedStore.is_open && asapAvailable) {
        todayEntry = {
          date: todayDateStr,
          formatted: this.formatScheduleDayLabel(todayDateStr, todayDateStr),
          hours: [],
        }
        availableHoursList.push(todayEntry)
      }

      if (todayEntry) {
        if (this.selectedStore.is_open && asapAvailable) {
          todayEntry.hours.unshift({
            hour: 'ASAP',
            asapTime: restaurantCurrentTimeWithTimezone,
            formatted: 'ASAP',
          })
        } else if (todayEntry.hours.length === 0) {
          // Nothing to offer today (no remaining slots and ASAP not available) - drop it
          availableHoursList = availableHoursList.filter((d) => d.date !== todayDateStr)
        }
      }
      // sort by date
      availableHoursList.sort((a, b) => {
        return moment(a.date).diff(moment(b.date))
      })
      if (this.storeConfig?.disable_future_orders) {
        if (availableHoursList.length > 0) {
          const selectedDays = [{ ...availableHoursList[0], hours: [] }]
          selectedDays.forEach((day) => {
            day.hours.push({
              hour: 'ASAP',
              asapTime: restaurantCurrentTimeWithTimezone,
              formatted: 'ASAP',
            })
          })
          this.SET_SELECTED_STORE_DAYS(selectedDays)
          this.dayAndTimeSelected = false
          localStorage.setItem('selectedStoreDays', JSON.stringify(selectedDays))
        }
      } else {
        this.SET_SELECTED_STORE_DAYS(availableHoursList)
        localStorage.setItem('selectedStoreDays', JSON.stringify(availableHoursList))

        // Check if no available hours after processing
        if (availableHoursList.length === 0 || availableHoursList.every((day) => day.hours.length === 0)) {
          this.isStoreTemporarilyClosed = true
          this.SET_SELECTED_STORE_DAYS([])
          return
        }
      }
      if (this.selectedStoreDays && !this.dayAndTimeSelected) {
        this.day = this.selectedStoreDays[0]
        this.hour = this.selectedStoreDays[0].hours[0]
      } else {
        // find the index of the selected day
        this.selectedDayIndex = this.selectedStoreDays.findIndex((day) => day.date === this.selectedDay.date)
        if (this.selectedDayIndex == -1) {
          this.selectedDayIndex = 0
        }
        // find the index of the selected hour
        try {
          this.selectedHourIndex = this.selectedStoreDays[this.selectedDayIndex].hours.findIndex(
            (hour) => hour.hour === this.selectedHour.hour
          )
          this.day = this.selectedStoreDays[this.selectedDayIndex]
        } catch (error) {
          this.selectedHourIndex = -1
        }
        if (this.selectedHourIndex == -1) {
          this.hour = this.selectedStoreDays[this.selectedDayIndex].hours[0]
          this.selectedHourIndex = 0
        } else {
          this.hour = this.selectedStoreDays[this.selectedDayIndex].hours[this.selectedHourIndex]
        }
        if (this.selectedHour.isNextDay) {
          // Adjust the day to the previous day
          const previousDayIndex = this.selectedDayIndex - 1
          if (previousDayIndex >= 0) {
            this.selectedDayIndex = previousDayIndex
            this.day = this.selectedStoreDays[previousDayIndex]
            this.hour = this.selectedHour
            this.selectedHourIndex = this.selectedStoreDays[previousDayIndex].hours.findIndex(
              (hour) => hour.hour === this.selectedHour.hour
            )
          }
        }
      }
    },
    checkClosingSoonForASAP(leadTime, prepTime, currentMinutes, yesterdayClosingTime, todayClosingTime) {
      let timeMargin = Math.max(leadTime, prepTime) + 5
      let closingSoonTime

      if (yesterdayClosingTime > 0) {
        closingSoonTime = yesterdayClosingTime - timeMargin
      } else if (todayClosingTime > 0) {
        closingSoonTime = todayClosingTime - timeMargin
      } else {
        return { showClosingSoonMessage: false, timeLeft: -1 }
      }

      if (currentMinutes + 30 >= closingSoonTime && currentMinutes < closingSoonTime) {
        return { showClosingSoonMessage: true, timeLeft: closingSoonTime - currentMinutes }
      } else {
        return { showClosingSoonMessage: false, timeLeft: -1 }
      }
    },
    showClosingSoonMessage(timeLeft) {
      const minutesLeft = Math.floor(timeLeft % 60)

      if (timeLeft <= 30) {
        this.closingSoonMessage = this.t('storeModal.dateAndTime.closingSoon', { minutes: minutesLeft })
        this.closingSoonMessageShow = true
      }
    },
    calculateTimeToHour(h) {
      return ('0' + Math.floor(parseInt(h) / 60)).slice(-2) + ':' + ('0' + (h % 60)).slice(-2)
    },
    setAutoCompleteType() {
      if (this.storeConfig?.enable_google_places_api) {
        this.SET_AUTO_COMPLETE_TYPE('GOOGLE')
      } else {
        this.SET_AUTO_COMPLETE_TYPE('RADAR')
      }
    },
    handleDayKeydown(event) {
      // Handle keyboard navigation for day dropdown
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        this.toggleDayDropdown()
      } else if (event.key === 'Escape' && this.dayDropdownIsOpen) {
        event.preventDefault()
        event.stopPropagation()
        this.dayDropdownIsOpen = false
      } else if (event.key === 'ArrowDown') {
        event.preventDefault()
        // Navigate to next day (works whether dropdown is open or closed)
        const nextIndex = Math.min(this.selectedDayIndex + 1, this.selectedStoreDays.length - 1)
        this.selectDay(nextIndex)
      } else if (event.key === 'ArrowUp') {
        event.preventDefault()
        // Navigate to previous day (works whether dropdown is open or closed)
        const prevIndex = Math.max(this.selectedDayIndex - 1, 0)
        this.selectDay(prevIndex)
      } else if (event.key === 'Home') {
        event.preventDefault()
        // Jump to first day
        this.selectDay(0)
      } else if (event.key === 'End') {
        event.preventDefault()
        // Jump to last day
        this.selectDay(this.selectedStoreDays.length - 1)
      }
    },
    handleHourKeydown(event) {
      // Handle keyboard navigation for time dropdown
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        this.toggleHourDropdown()
      } else if (event.key === 'Escape' && this.hourDropdownIsOpen) {
        event.preventDefault()
        event.stopPropagation()
        this.hourDropdownIsOpen = false
      } else if (
        (event.key === 'ArrowDown' || event.key === 'ArrowUp') &&
        this.selectedStoreDays[this.selectedDayIndex]
      ) {
        event.preventDefault()
        // Navigate through times (works whether dropdown is open or closed)
        const hours = this.selectedStoreDays[this.selectedDayIndex].hours
        if (event.key === 'ArrowDown') {
          const nextIndex = Math.min(this.selectedHourIndex + 1, hours.length - 1)
          this.selectHour(nextIndex)
        } else {
          const prevIndex = Math.max(this.selectedHourIndex - 1, 0)
          this.selectHour(prevIndex)
        }
      } else if (event.key === 'Home' && this.selectedStoreDays[this.selectedDayIndex]) {
        event.preventDefault()
        // Jump to first time slot
        this.selectHour(0)
      } else if (event.key === 'End' && this.selectedStoreDays[this.selectedDayIndex]) {
        event.preventDefault()
        // Jump to last time slot
        const hours = this.selectedStoreDays[this.selectedDayIndex].hours
        this.selectHour(hours.length - 1)
      }
    },
  },
  created() {
    this.getStoreServices()
    // Only set selectedStoreId from route if it exists; otherwise prefer prop storeId
    if (this.$route && this.$route.params && this.$route.params.storeId) {
      localStorage.setItem('selectedStoreId', this.$route.params.storeId)
    } else if (this.storeId) {
      localStorage.setItem('selectedStoreId', this.storeId)
    }
    this.addressInputIsVisible = this.selectedAddress ? false : true
    this.setAutoCompleteType()
  },
  mounted() {
    this.useASAPOrdersScheduler = this.branding?.display_options?.asap_schedule_toggle_enabled === true
    if (!this.useASAPOrdersScheduler) {
      this.selectedOrderType = 'future'
    }
    this.guestCount = this.orderData?.order?.guest_count || null
    this.handleDocumentClick = (e) => {
      if (this.dayDropdownIsOpen) {
        const dayRef = this.$refs.dayDropdown
        if (dayRef && !dayRef.contains(e.target)) {
          this.dayDropdownIsOpen = false
        }
      }
      if (this.hourDropdownIsOpen) {
        const hourRef = this.$refs.hourDropdown
        if (hourRef && !hourRef.contains(e.target)) {
          this.hourDropdownIsOpen = false
        }
      }
    }
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeUnmount() {
    if (this.handleDocumentClick) {
      document.removeEventListener('click', this.handleDocumentClick)
    }
  },
}
</script>

<style src="../../../assets/css/Modals/StoreModals/DateAndTimeModal.css" scoped>
</style>